import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import pb from '../lib/pocketbase';
import './account.css';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!token) {
      setError('Lien invalide ou expiré.');
      return;
    }
    if (!password || password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }
    if (password !== passwordConfirm) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    try {
      setLoading(true);
      await pb.collection('users').confirmPasswordReset(token, password, passwordConfirm);
      setSuccess('Votre mot de passe a été mis à jour. Redirection vers votre espace Mon Compte...');
      setTimeout(() => {
        navigate('/mon-compte');
      }, 1500);
    } catch (e) {
      console.error('Erreur reset password:', e);
      setError("Impossible de réinitialiser le mot de passe. Le lien est peut-être expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-page">
      <div className="container">
        <div className="card">
          <h2>Réinitialiser votre mot de passe</h2>
          <p style={{ marginBottom: 12, color: '#6b7280' }}>
            Choisissez un nouveau mot de passe pour votre compte.
          </p>
          <form onSubmit={handleSubmit} className="grid" style={{ maxWidth: 480 }}>
            <input
              type="password"
              placeholder="Nouveau mot de passe (min. 8 caractères)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="Confirmer le nouveau mot de passe"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
            {error && <div className="error-message" style={{ gridColumn: '1/-1' }}>{error}</div>}
            {success && <div className="success-message" style={{ gridColumn: '1/-1' }}>{success}</div>}
            <div className="actions">
              <button
                type="submit"
                className="btn primary"
                disabled={loading}
              >
                {loading ? 'Réinitialisation…' : 'Mettre à jour le mot de passe'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
